import React from 'react'

export default class SoftwareCard extends React.Component {
  constructor() {
    super()
    this.onCheckboxChange = this.onCheckboxChange.bind(this)
  }

  onCheckboxChange(e) {
    return this.props.onSoftwareCheckboxChange(
      e.currentTarget.value,
      e.currentTarget.checked
    )
  }

  render() {
    const softwareId = `software-${this.props.data.id}`
    const checked = this.props.selectedSoftware.indexOf(this.props.data.attributes.name) >= 0

    return (
      <div className="section__item">
        <input
          id={softwareId}
          className="checkbox is-spaced"
          type="checkbox"
          checked={checked}
          value={this.props.data.attributes.name}
          onChange={this.onCheckboxChange}
          ref={(input) => { this.softwareCheckbox = input }}
        />

        <label htmlFor={softwareId}>{this.props.data.attributes.name}</label>
      </div>
    )
  }
}
